module.exports = __webpack_public_path__ + "static/img/spools.8ff3da5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/art/drawing_painting/spools.jpg
// module id = zZ5a
// module chunks = 1